import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
function Surveys() {
  return (
    <>
    <SubHeader title="Surveys" description={"Clinic Surveys "}/>
    <div className='app-container container-xxl'>
           Survey content
    </div>
</>
  )
}

export default Surveys